export const SUPPORTED_LOCALES = [
  'af',
  'sq',
  'am',
  'ar',
  'hy',
  'as',
  'az',
  'bn',
  'ba',
  'eu',
  'be',
  'bs',
  'pt-BR',
  'br',
  'bg',
  'my',
  'ca',
  'tzm',
  'ckb',
  'zh',
  'syc',
  'co',
  'hr',
  'cs',
  'da',
  'prs',
  'dv',
  'nl',
  'en',
  'et',
  'pt-PT',
  'fo',
  'fil',
  'fi',
  'fr',
  'gl',
  'ka',
  'de',
  'gil',
  'el',
  'gu',
  'ha',
  'he',
  'hi',
  'hu',
  'is',
  'ig',
  'smn',
  'id',
  'iu',
  'ga',
  'it',
  'ja',
  'kl',
  'kn',
  'kk',
  'km',
  'rw',
  'kok',
  'ko',
  'ku',
  'ky',
  'quc',
  'lo',
  'lv',
  'lt',
  'dsb',
  'smj',
  'lb',
  'mk',
  'ms',
  'ml',
  'mt',
  'mi',
  'arn',
  'mr',
  'moh',
  'mn',
  'ary',
  'ne',
  'se',
  'no',
  'nb',
  'nn',
  'oc',
  'or',
  'pap',
  'ps',
  'fa',
  'pl',
  'pt',
  'pa',
  'qu',
  'ro',
  'rm',
  'ru',
  'sa',
  'gd',
  'sr',
  'ii',
  'zh-Hans',
  'si',
  'sms',
  'sk',
  'sl',
  'sma',
  'st',
  'es',
  'sw',
  'sv',
  'gsw',
  'tg',
  'ta',
  'tt',
  'te',
  'th',
  'bo',
  'zh-Hant',
  'tn',
  'tr',
  'tk',
  'uk',
  'hsb',
  'ur',
  'ug',
  'uz',
  'vi',
  'cy',
  'fy',
  'wo',
  'xh',
  'sah',
  'yo',
  'zu',
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const LOCALE_NAME_FALLBACKS: Record<string, string> = {
  ba: 'Bashkir',
  tzm: 'Central Atlas Tamazight',
  syc: 'Classical Syriac',
  gil: 'Gilbertese',
  smn: 'Inari Sami',
  iu: 'Inuktitut',
  kl: 'Kalaallisut',
  quc: "K'iche'",
  dsb: 'Lower Sorbian',
  smj: 'Lule Sami',
  arn: 'Mapudungun',
  moh: 'Mohawk',
  ary: 'Moroccan Arabic',
  se: 'Northern Sami',
  pap: 'Papiamento',
  ii: 'Sichuan Yi',
  sms: 'Skolt Sami',
  sma: 'Southern Sami',
  gsw: 'Swiss German',
  bo: 'Tibetan',
  hsb: 'Upper Sorbian',
  sah: 'Yakut',
};

export const getLocaleDisplayName = (locale: string): string => {
  if (LOCALE_NAME_FALLBACKS[locale]) {
    return LOCALE_NAME_FALLBACKS[locale];
  }

  try {
    const displayName = new Intl.DisplayNames(['en'], { type: 'language' }).of(
      locale
    );
    if (displayName && displayName !== locale) {
      return displayName;
    }
  } catch (error) {
    // Intl.DisplayNames failed, fall through to fallback
  }

  return locale;
};
